const APPROVED = 'approved';
const OPEN = 'open';
// Tilattu materiaalina: final and counted as ordered like APPROVED, but no project is made
// of it in ProBuilder
const ORDERED_AS_MATERIAL = 'ordered-as-material';
// Lähetysvalmis: an indicator for the checker that the offer is finished. It does not lock
// the offer, only sending does.
const READY_TO_SEND = 'ready-to-send';
const REJECTED = 'rejected';
const SENT = 'sent';

// The statuses of the offers in the order of their life
const OFFER_STATUSES = [
  OPEN,
  READY_TO_SEND,
  SENT,
  APPROVED,
  ORDERED_AS_MATERIAL,
  REJECTED,
];

// Ordered as a whole or as material: final, and counted as ordered
const isOrderedStatus = (status: null | string | undefined): boolean =>
  status === APPROVED || status === ORDERED_AS_MATERIAL;

// The closing statuses of an opportunity
const NOT_REALIZED = 'not-realized';
const LOST = 'lost';
const CONVERTED_TO_PRELIMINARY_OFFER = 'converted-preliminary-offer';
const CONVERTED_TO_OFFER = 'converted-offer';

const OPPORTUNITY_STATUSES = [
  OPEN,
  NOT_REALIZED,
  LOST,
  CONVERTED_TO_PRELIMINARY_OFFER,
  CONVERTED_TO_OFFER,
];

// The opportunity has been made an offer or a preliminary offer: closed for good
const isConvertedStatus = (status: null | string | undefined): boolean =>
  status === CONVERTED_TO_OFFER || status === CONVERTED_TO_PRELIMINARY_OFFER;

// A closed opportunity is kept as it was closed (its status can still be reopened unless
// it was converted)
const isClosedOpportunityStatus = (
  status: null | string | undefined
): boolean =>
  status === NOT_REALIZED || status === LOST || isConvertedStatus(status);

export {
  APPROVED,
  CONVERTED_TO_OFFER,
  CONVERTED_TO_PRELIMINARY_OFFER,
  LOST,
  NOT_REALIZED,
  OFFER_STATUSES,
  OPEN,
  OPPORTUNITY_STATUSES,
  ORDERED_AS_MATERIAL,
  READY_TO_SEND,
  REJECTED,
  SENT,
  isClosedOpportunityStatus,
  isConvertedStatus,
  isOrderedStatus,
};
